var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{class:_vm.btnClasses,attrs:{"icon":"","outlined":"","medium":""},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v("mdi-plus")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }